import { 
    CreatePackageActivityDto, 
    DeletePackageActivityDto,
    EditPackageActivityDto,
    GetPackageActivityDto, 
    MessageResponseDto, 
    PackageActivityApiFp,
    PackageActivityControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePackageActivityModel = PackageActivityControllerGet200Response;
export type GetPackageActivityModel = GetPackageActivityDto;
export type MutateResponsePackageActivityModel = MessageResponseDto;
export type CreatePackageActivityModel = CreatePackageActivityDto;
export type UpdatePackageActivityModel = EditPackageActivityDto;
export type DeletePackageActivityModel = DeletePackageActivityDto;

export const apiPackageActivityFp = PackageActivityApiFp(apiConfig);
export const getPackageActivityController = apiPackageActivityFp.packageActivityControllerGet;
export const createPackageActivityController = apiPackageActivityFp.packageActivityControllerCreate;
export const updatePackageActivityController = apiPackageActivityFp.packageActivityControllerEdit;
export const deletePackageActivityController = apiPackageActivityFp.packageActivityControllerDelete;

export const QueryKeyPackageActivity = QueryKey.PackageActivity;